import classes from "./LoginWithPhone.module.css";
import logo from "./../../assets/icons/Logo_register.png";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

function LoginWithPhone() {
  const [isSend, setIsSend] = useState(false);
  const [hasFailed, setHasFailed] = useState(false);
  const [username, setUsername] = useState("");
  const [message, setMessage] = useState("");
  const [token, setToken] = useState("");
  const navigate = useNavigate();

  function getSMS() {
    setHasFailed(false);
    setMessage(null);
    setIsSend(false);

    setUsername(phoneInputRef.current.value);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    const urlencoded = new URLSearchParams();
    urlencoded.append("username", phoneInputRef.current.value);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_API_URL}/api/v1/user/login`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.data) {
          setMessage(result.message);
          setToken(result.data.token);
          localStorage.setItem("token", result.data.token);
          setIsSend(true);
          toast.success("کد احراز هویت برای شما ارسال شد");
        } else {
          setMessage(result.message);
          setHasFailed(true);
          toast.error(result.error?.description || "Unknown error occurred");
        }
      })
      .catch((error) => {
        toast.error("خطا در اتصال ");
      });
  }

  function enter() {
    setHasFailed(false);
    setMessage(null);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    const urlencoded = new URLSearchParams();
    urlencoded.append("code", passInputRef.current.value);
    urlencoded.append("token", token);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_API_URL}/api/v1/user/check`, requestOptions)
      .then((response) => response.json())
      .then((respObj) => {
        if (respObj.data) {
          const date = new Date();
          let time = date.getTime();
          localStorage.setItem("token", respObj.data.token);
          localStorage.setItem("tokenSetTime", time);
          localStorage.setItem(
            "name",
            respObj.firstname + " " + respObj.lastname
          );
          localStorage.setItem("username", respObj.username);
          localStorage.setItem("refresh_token", respObj.data.refresh_token);
          navigate("/", { state: { Object: respObj } });
        } else {
          setMessage(respObj.message);
          setHasFailed(true);
          toast.error(respObj.error?.description || "Unknown error occurred");
        }
      })
      .catch((error) => {
        setHasFailed(true);
        toast.error("An unexpected error occurred.");
      });
  }

  const phoneInputRef = useRef();
  const passInputRef = useRef();

  const component = (
    <>
      <p className={classes.error}>{message}</p>
      <input
        type="text"
        placeholder="رمز عبور پیامک شده"
        className={classes.input}
        ref={passInputRef}
        id="password"
      />
      <button className={classes.enter} onClick={enter}>
        ورود
      </button>
    </>
  );

  const failComponent = <div className={classes.error}>{message}</div>;

  return (
    <div className={classes.container}>
      <div className={classes.section_logo}>
        <img className={classes.logo_img} alt="Logo" src={logo} />
      </div>
      <div className={classes.section_form}>
        <div>
          <input
            type="text"
            placeholder="شماره موبایل"
            className={classes.input}
            ref={phoneInputRef}
            required
            id="username"
          />
          {hasFailed ? failComponent : null}
        </div>
        <button className={classes.askSMS} onClick={getSMS}>
          دریافت پیامک
        </button>
        <button className={classes.recieve_SMS} onClick={() => navigate(-1)}>
          بازگشت
        </button>
        {isSend ? component : null}
      </div>
    </div>
  );
}

export default LoginWithPhone;
